
import axios from "axios"

export function getStockoutItemList (id) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/stockout/${id}/get-stockout-items`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};